// src/rms/pages/hfpTest/hfpTestSession.js
/**
 * Shared state and constants for the staging-only HFP test site.
 *
 * The "session" (which tester, which demo patient record, which role) is held
 * in sessionStorage so it survives navigation between the dashboard and the
 * forms without any auth. It is intentionally scoped to the browser tab.
 */

const SESSION_KEY = 'hfp-test-session-v1';

/** Persist the provisioned/looked-up session for this tab. */
export function saveHfpTestSession(session) {
  try {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(session));
  } catch { /* non-critical */ }
}

/** Read the current session, or null if none. */
export function loadHfpTestSession() {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** Clear the session (e.g. "start over"). */
export function clearHfpTestSession() {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch { /* non-critical */ }
}

/**
 * The 7 HFP v2 tiles, mirrored byte-for-byte from ServiceUserPatientOverview's
 * strengthsScalesItems so the test dashboard matches the real one. `key` is the
 * kebab route slug; `formKey` is the camelCase schema/instance key.
 */
export const HFP_TEST_TILES = [
  { title: 'Executive Function', subtitle: 'Focus, planning, organising and adapting', key: 'hfp-v2-executive-function', formKey: 'hfpV2ExecutiveFunction' },
  { title: 'Motor & Physical', subtitle: 'Movement, coordination and physical skills', key: 'hfp-v2-motor-physical', formKey: 'hfpV2MotorPhysical' },
  { title: 'Speech, Language & Communication', subtitle: 'Understanding and expressing themselves', key: 'hfp-v2-speech-language-communication', formKey: 'hfpV2SpeechLanguageCommunication' },
  { title: 'Social & Emotional', subtitle: 'Feelings, relationships and managing emotions', key: 'hfp-v2-social-emotional', formKey: 'hfpV2SocialEmotional' },
  { title: 'Sensory', subtitle: 'How they experience and respond to sensory input', key: 'hfp-v2-sensory', formKey: 'hfpV2Sensory' },
  { title: 'Global Participation', subtitle: 'Taking part in everyday activities and life', key: 'hfp-v2-global-participation', formKey: 'hfpV2GlobalParticipation' },
  { title: 'Environmental Factors', subtitle: 'Supports and barriers around them', key: 'hfp-v2-environmental-factors', formKey: 'hfpV2EnvironmentalFactors' },
];

/** Map a kebab tile key back to its camelCase formKey. */
export function formKeyForTileKey(tileKey) {
  const tile = HFP_TEST_TILES.find((t) => t.key === tileKey);
  return tile ? tile.formKey : null;
}
